import { Brand, createBranded } from '@deltasierra/type-utilities';
import { FullAuditable, HasId, PathBuilder, Url, ApiRoute, HttpMethod } from '../../common';
import { ClientId } from '../../client';
import { LocationId } from '../../location';

export type ExternalPrintPackageBannerId = Brand<number, 'ExternalPrintPackageBannerId'>;
export const ExternalPrintPackageBannerId = createBranded<ExternalPrintPackageBannerId>();

export interface ExternalPrintPackageBanner extends HasId<ExternalPrintPackageBannerId>, FullAuditable {
    bannerText: string;
    externalAppUrl: Url;
    clientId: ClientId;
}

export type GetExternalAppUrlResponse = Pick<ExternalPrintPackageBanner, 'externalAppUrl'>;

export interface ClientParams {
    clientId: ClientId;
}

export interface ExternalPrintPackageBannerParams extends ClientParams {
    externalPrintPackageBannerId: ExternalPrintPackageBannerId;
    locationId: LocationId;
}

const EXTERNAL_PRINT_PACKAGE_API_ROOT = <TParams extends ClientParams>(path: PathBuilder<TParams>) =>
    path.literal('externalPrintPackages').literal('client').param('clientId');
export const ExternalPrintPackageApi = {
    getExternalAppUrl: new ApiRoute<GetExternalAppUrlResponse, ExternalPrintPackageBannerParams, void, void>(
        HttpMethod.Get,
        path =>
            EXTERNAL_PRINT_PACKAGE_API_ROOT(path)
                .literal('printPackageBanner')
                .param('externalPrintPackageBannerId')
                .literal('location')
                .param('locationId')
                .literal('appUrl'),
    ),
    getExternalPrintPackageBanners: new ApiRoute<ExternalPrintPackageBanner[], ClientParams, void, void>(
        HttpMethod.Get,
        path => EXTERNAL_PRINT_PACKAGE_API_ROOT(path),
    ),
};
